import { Modal, Form, InputNumber, Select, List, Tag } from 'antd';
import { useState, useEffect } from 'react';
import { request } from '@/utils/request';

export type FindSimilarityCurrentPQ = { id: number; productName: string; question?: string; editForm?: any; }

interface IndexProps {
  productNames: { productName: string; productZhName: string; }[];
  findSimilarityCurrentPQ: FindSimilarityCurrentPQ;
  clearPQ: () => void;
}

const Index: React.FC<IndexProps> = ({ productNames, findSimilarityCurrentPQ, clearPQ }) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [data, setData] = useState<{ id: number; question: string; answer: string; productName: string }[]>([]);

  const [form] = Form.useForm();

  useEffect(() => {
    if (findSimilarityCurrentPQ?.id) {
      form.setFieldsValue({
        ...form.getFieldsValue(),
        productName: findSimilarityCurrentPQ.productName,
      })
      fetchData();
      setVisible(true);
    }
  }, [findSimilarityCurrentPQ?.id]);


  const clear = () => {
    setVisible(false);
    clearPQ();
  }

  const fetchData = async () => {
    const { resp } = await request("/local/knowledge/productQA/similarity", {
      method: "POST",
      data: {
        ...findSimilarityCurrentPQ,
        ...form.getFieldsValue(),
      }
    });
    if (resp?.code !== 0) return;
    setData(resp?.data.list);
  }

  return <Modal
    title="寻找相似问题的答案"
    visible={visible}
    onCancel={clear}
    width="70%"
    footer={null}
  >
    <Form form={form} initialValues={{ count: 5 }} onFieldsChange={fetchData}>
      <Form.Item label="产品" name="productName">
        <Select allowClear>
          {
            productNames.map(vo => <Select.Option key={vo.productName} value={vo.productName}>{vo.productZhName}</Select.Option>)
          }
        </Select>
      </Form.Item>
      <Form.Item label="数量" name="count">
        <InputNumber min={1} max={20} />
      </Form.Item>
    </Form>
    <h4>注：若是不选择产品，则全局查找！</h4>
    {data.length > 0 && <h3>相似度由高到低排列：</h3>}
    <List
      itemLayout="horizontal"
      dataSource={data}
      rowKey="id"
      renderItem={item => (
        <List.Item
          actions={[<a onClick={() => {
            findSimilarityCurrentPQ.editForm(findSimilarityCurrentPQ.question, item.answer
            );
            clear();
          }}>替换成此回答</a>]}
        >
          <List.Item.Meta
            title={[<Tag color="purple">{item.question}</Tag>, <Tag color="geekblue">{item.productName}</Tag>]}
            description={item.answer}
          />
        </List.Item>
      )}
    />
  </Modal>
}

export default Index;